import { render, staticRenderFns } from "./LoadingError.vue?vue&type=template&id=a2c68a20&scoped=true&"
import script from "./LoadingError.vue?vue&type=script&lang=js&"
export * from "./LoadingError.vue?vue&type=script&lang=js&"
import style0 from "./LoadingError.vue?vue&type=style&index=0&id=a2c68a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c68a20",
  null
  
)

export default component.exports